import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "common-alert-body"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  key: 2
};
const _hoisted_4 = {
  key: "confirm",
  class: "clearfix"
};
const _hoisted_5 = {
  key: "alert"
};
const _hoisted_6 = {
  type: "button",
  class: "common-alert-btn loading"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "nk-spinner"
}, null, -1);

const _hoisted_8 = {
  key: 0,
  class: "pl5"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_icon = _resolveComponent("ion-icon");

  const _component_Modal = _resolveComponent("Modal");

  return _openBlock(), _createBlock(_component_Modal, {
    "max-width": "320px",
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.closeDialog($event)),
    "align-y": _ctx.alignY,
    clickOut: _ctx.clickOut,
    "modal-transition": "slide-up",
    onAfterLeave: _ctx.afterLeave
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_ctx.hasClose ? (_openBlock(), _createBlock(_component_ion_icon, {
      key: 0,
      icon: "closeOutline",
      class: "common-alert-close-ico",
      onClick: _ctx.close
    }, null, 8, ["onClick"])) : _createCommentVNode("", true), _ctx.useHTML ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      innerHTML: _ctx.text
    }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.text), 1)), _ctx.type === 'confirm' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("button", {
      type: "button",
      class: "common-alert-btn type-2 fl",
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.ok && _ctx.ok(...args))
    }, _toDisplayString(_ctx.okText), 1), _createElementVNode("button", {
      type: "button",
      class: "common-alert-btn type-2 fr",
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.cancel && _ctx.cancel(...args))
    }, _toDisplayString(_ctx.cancelText), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_withDirectives(_createElementVNode("button", {
      type: "button",
      class: "common-alert-btn",
      onClick: _cache[2] || (_cache[2] = (...args) => _ctx.ok && _ctx.ok(...args))
    }, _toDisplayString(_ctx.okText), 513), [[_vShow, !_ctx.isLoading]]), _withDirectives(_createElementVNode("button", _hoisted_6, [_hoisted_7, _ctx.LoadingText ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.LoadingText), 1)) : _createCommentVNode("", true)], 512), [[_vShow, _ctx.isLoading]])]))])]),
    _: 1
  }, 8, ["modelValue", "align-y", "clickOut", "onAfterLeave"]);
}